import { initializeApp, getApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import Toast from 'react-native-toast-message';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCTgFQMU6mT--hqrq16JQDPrR3Dc9tMuiE",
  authDomain: "eventapp-a504d.firebaseapp.com",
  projectId: "eventapp-a504d",
  storageBucket: "eventapp-a504d.firebasestorage.app",
  messagingSenderId: "923349513093",
  appId: "1:923349513093:web:243979e9cf2e0165204aec"
};

// Initialize Firebase
let app;
let messaging;

try {
  if (typeof window !== 'undefined') {
    try {
      app = getApp();
    } catch (e) {
      app = initializeApp(firebaseConfig);
    }
    messaging = getMessaging(app);
  }
} catch (error) {
  console.log('Firebase initialization error:', error);
}

export const initializeFirebase = async () => {
  if (typeof window === 'undefined') return null;
  
  if (!('serviceWorker' in navigator)) {
    console.log('Service Worker not supported');
    return null;
  }

  try {
    // Register service worker first - CORRECTED PATH
    console.log('Registering service worker...');
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
      scope: '/'
    });
    console.log('Service Worker registered:', registration);

    // Wait for service worker to be ready
    await navigator.serviceWorker.ready;
    console.log('Service Worker is ready');

    // Check if messaging is available
    if (!messaging) {
      console.error('Messaging is not initialized');
      return null;
    }

    // Request notification permission
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Notification permission not granted');
      return null;
    }

    console.log('Getting FCM token...');
    // Get FCM token
    const currentToken = await getToken(messaging, {
      vapidKey: 'BKpn0VKsrCq14m4lxjj7PRvOYVf_iSp1b8F3_xv_9TX8DnUMswhsalAtYfcYPFAPghlJBUfB6X7aRPxM4XjbcPQ',
      serviceWorkerRegistration: registration
    });
    
    if (currentToken) {
      console.log('FCM token received:', currentToken);
      return currentToken;
    } else {
      console.log('No token received');
      return null;
    }
  } catch (error) {
    console.error('Error initializing Firebase:', error);
    return null;
  }
};

// CORRECTED: Simplified onMessage listener
export const onMessageListener = () => {
  return new Promise((resolve, reject) => {
    if (!messaging) {
      reject(new Error('Messaging not initialized'));
      return;
    }

    try {
      const unsubscribe = onMessage(messaging, (payload) => {
        const { title, body } = payload.notification || {};
        console.log('Message received in foreground:', payload);
        
        // Show toast notification
        Toast.show({
          type: 'info',
          text1: title || 'Notification',
          text2: body || '',
          position: 'top',
          visibilityTime: 4000,
        });
        
        resolve(payload);
      });
      
      // Return the unsubscribe function
      return unsubscribe;
    } catch (error) {
      console.error('Error setting up message listener:', error);
      reject(error);
    }
  });
};

// ADDED: Better function to set up foreground listener
export const setupForegroundListener = () => {
  if (!messaging) {
    console.log('Messaging not available');
    return null;
  }

  return onMessage(messaging, (payload) => {
    const { title, body } = payload.notification || {};
    console.log('📨 Received foreground message:', payload);
    
    // Show toast notification
    Toast.show({
      type: 'info',
      text1: title || 'Notification',
      text2: body || '',
      position: 'top',
      visibilityTime: 4000,
    });

    // Optionally show browser notification too
    if (Notification.permission === "granted") {
      new Notification(title || "New Message", {
        body: body || "You have a new notification",
        icon: "/icon.png",
        tag: 'foreground-notification'
      });
    }
  });
};

export default app;